import { FC } from 'react';
import { Capacitor } from '@capacitor/core';
import classNames from 'classnames';
import { RadabankCardPreview } from 'components/RadabankCard';
import { CustomButton } from 'components/shared';
import { CardBannerContent } from './Content';
import styles from './index.module.scss';

interface CardBannerProps {
	isActionsDisabled?: boolean;

	onClick: () => void;
}

export const CardBanner: FC<CardBannerProps> = ({ isActionsDisabled = false, onClick }) => {
	const isIOS = Capacitor.getPlatform() === 'ios';
	const isWeb = Capacitor.getPlatform() === 'web';

	return (
		<div className={classNames(styles.wrapper, { [styles['wrapper--web']]: isWeb, [styles['wrapper--ios']]: isIOS })}>
			<div className={styles.content}>
				<RadabankCardPreview className={styles.card} />
				<CardBannerContent />
			</div>
			{!isActionsDisabled && (
				<div className={styles.actions}>
					<CustomButton label="Замовити" onClick={onClick} />
				</div>
			)}
		</div>
	);
};
